// src/services/lab/messagerieService.js
//
// Aucune fonction ne prend d'identifiant d'utilisateur : le backend déduit
// l'identité du token. C'est ce qui ferme l'IDOR du Lab, où
// /api/formateurs/:id/notifications acceptait n'importe quel :id sans token.
import api from '../api';

const BASE = 'messagerie/';

// ── Notifications ──
export const getNotifications = async (nonLues = false) => {
  const res = await api.get(`${BASE}notifications/`, {
    params: nonLues ? { non_lues: 1 } : {},
  });
  return res.data; // { non_lues, notifications: [...] }
};

export const marquerNotificationLue = async (id) => {
  const res = await api.post(`${BASE}notifications/${id}/lire/`);
  return res.data;
};

export const marquerToutesLues = async () => {
  const res = await api.post(`${BASE}notifications/tout-lire/`);
  return res.data;
};

export const supprimerNotification = async (id) => {
  const res = await api.delete(`${BASE}notifications/${id}/`);
  return res.data;
};

// ── Messages ──
export const getMessages = async (boite = 'reception', nonLus = false) => {
  const res = await api.get(`${BASE}messages/`, {
    params: { boite, ...(nonLus ? { non_lus: 1 } : {}) },
  });
  return res.data; // { non_lus, messages: [...] }
};

export const getMessage = async (id) => {
  const res = await api.get(`${BASE}messages/${id}/`);
  return res.data;
};

export const envoyerMessage = async (destinataireId, objet, contenu) => {
  const res = await api.post(`${BASE}messages/`, {
    destinataire: destinataireId, objet, contenu,
  });
  return res.data;
};

/** Envoi groupé (équipe du centre) : groupe ∈ tous | administration | formateurs | etudiants. */
export const envoyerMessageGroupe = async (groupe, objet, contenu) => {
  const res = await api.post(`${BASE}messages/`, { groupe, objet, contenu });
  return res.data; // { envoyes: n }
};

/** Suppression asymétrique : retire le message de SA vue, pas de celle de l'autre. */
export const supprimerMessage = async (id) => {
  const res = await api.delete(`${BASE}messages/${id}/`);
  return res.data;
};

export const getDestinataires = async (search = '') => {
  const res = await api.get(`${BASE}destinataires/`, {
    params: search ? { search } : {},
  });
  return res.data;
};
